<script setup lang="ts">
import type { Component } from 'vue'
import ManPointingAtCommentary from '~/components/illustration/ManPointingAtCommentary.vue'
import FeatherPen from '~/components/illustration/FeatherPen.vue'
import ClosedBook from '~/components/illustration/ClosedBook.vue'

type IllustrationType = 'man-pointing' | 'feather-pen' | 'closed-book'

interface Props {
  illustration: IllustrationType
  gap?: 's' | 'xl'
}

const props = withDefaults(defineProps<Props>(), {
  gap: 's',
})

const illustrationMap: Record<IllustrationType, Component> = {
  'man-pointing': ManPointingAtCommentary,
  'feather-pen': FeatherPen,
  'closed-book': ClosedBook,
}
</script>

<template>
  <div
    :class="[
      'flex flex-col text-center dark:text-white items-center justify-center justify-self-center overflow-hidden top-[42%] absolute transform -translate-y-1/2',
      gap === 's' ? 'gap-s' : 'gap-xl'
    ]"
    role="status"
    aria-live="polite"
  >
    <component :is="illustrationMap[illustration]" aria-hidden="true" class="flex-shrink-0" />
    <slot />
  </div>
</template>
